import { render } from "./pfab.vue?vue&type=template&id=76ed9ad8"
import script from "./pfab.vue?vue&type=script&lang=js"
export * from "./pfab.vue?vue&type=script&lang=js"

import "./pfab.vue?vue&type=style&index=0&id=76ed9ad8&lang=less"

import exportComponent from "D:\\DAIHAO\\AAAAA\\smart_brain_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__